import { useQuery } from '@tanstack/react-query';

import { MlsLookupApi } from '../api/mlsLookup.api';

const MLS_QUERY_KEY = 'mls-lookup';
export const useMls = (mlsId: number | null) => {
  return useQuery(
    [MLS_QUERY_KEY, mlsId],
    async () => {
      return await MlsLookupApi.fetchMls(mlsId);
    },
    {
      enabled: mlsId !== null
    }
  );
};
